import { AfterViewInit, Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { DialogService } from "src/app/shared/components/dialog/service/dialog.service";
import { MobileComponent } from "src/app/shared/components/mobile/interface/mobile.component";
import { HierarchyManagementService } from "src/app/shared/service/store-management/hierarchy-management/hierarchy-management.service";
import { ProfileManagementService } from "src/app/shared/service/store-management/profile-management/profile-management.service";

import { HierarchyComponent } from "../../../feature/hierarchy/hierarchy.component";
import { SubSink } from "subsink";
import { CsManagementService } from "src/app/shared/service/store-management/cs-management/cs-management.service";
import { CommonModule } from "@angular/common";
import { delay, filter, map, Subject, switchMap, tap } from "rxjs";

@Component({
    selector: "ald-sub-header",
    templateUrl: "./sub-header.component.html",
    styleUrls: ["./sub-header.component.scss"],
    imports: [
        CommonModule
    ]
})
export class SubHeaderComponent extends MobileComponent implements OnInit, AfterViewInit, OnDestroy {
  private subs = new SubSink();
  isCustomer: boolean;
  firstTry: boolean = false;
  hierarchy: any;
  hierarchySelectedWithName: any;

  private getLeasingLabel$: Subject<void> = new Subject<void>();

  constructor(
    private dialog: DialogService,
    private router: Router,
    private profileManagementService: ProfileManagementService,
    private csManagementService: CsManagementService,
    private hierarchyManagementService: HierarchyManagementService
  ) {
    super();
  }

  leasingLabel: string = "";
  initCustomer() {
    this.profileManagementService.getCustomerServiceRole().subscribe(customerServiceRoles => {

    })
  }

  ngAfterViewInit(): void {
    this.getLeasingLabel$.next();
  }

  ngOnInit(): void {
    this.hierarchy = this.hierarchyManagementService.getHierarchyStored();
    this.hierarchySelectedWithName = this.hierarchyManagementService.getHierarchySelectedWithName();

    this.subs.add(
      this.getLeasingLabel$.pipe(
        switchMap(() => this.profileManagementService.getCustomerServiceRole()),
        map((customerServiceRoles) => {
          const rawToken = sessionStorage.getItem('id_token');
          if (!rawToken) return;

          const token = this.getDecodedAccessToken(rawToken);
          const profile = JSON.parse(sessionStorage.getItem("profile"));
          const customerKey = token?.roles ? token.roles[0] : null;
          this.isCustomer = customerServiceRoles.some((csKey) => csKey === customerKey);

          if (this.isCustomer && profile?.leasing_companies?.[0]?.name) {
            return this.leasingLabel = ` - Leasing Company ${profile.leasing_companies[0].name}`;
          } else {
            return this.leasingLabel = "";
          }
        }),
        filter((leadingLabel)=> !leadingLabel),
        delay(1000),
        tap(() => {
          this.getLeasingLabel$.next();
        })
      ).subscribe()
    );
  }

  ngOnDestroy(): void {
    // Tear down the self-retriggering getLeasingLabel$ loop; otherwise it keeps
    // re-emitting every second forever on a destroyed component (subscription leak).
    this.subs.unsubscribe();
  }

  getProfile(): any {
    const profile = JSON.parse(sessionStorage.getItem("profile"));
    this.showCodplateForDriver();
    return profile;
  }

  // isFleetManager(): boolean {
  //   const profile = this.getProfile();
  //   const role = !!profile ? +profile.role : null;
  //   return (
  //     !!profile &&
  //     ((this.isNotDriver(role) && !profile.isConsumer) || profile.isSales)
  //   );
  // }

  isFleetManagerOrTempDriver(): boolean {
    const profile = this.getProfile();
    if (!!profile && (profile.role === '2' || profile.role === '7' || profile.role === '9' || profile.role === '10' || profile.role === '400031' || profile.role === '400028')) {
      return true
    }
  }

  isNotDriver(role): boolean {
    return role !== 1 && role !== 5 && role !== 8 && role !== 3 && role !== 9 && role != 400028;
  }

  isCorporateQuoterRole() {
    const profile = this.getProfile();
    if (!!profile && (profile.role === '400035' || profile.role === '400036' || profile.role === '400037')) {
      return true
    }
  }

  isDriverCorporateQuoterRole() {
    const profile = this.getProfile();
    if (!!profile && (profile.role === '400038')) {
      return true
    }
  }

  openHierarchy(isMobile): void {
    const profile = this.getProfile();
    if (profile.isConsumer === false && this.isFleetManagerOrTempDriver()) {
      this.subs.add(
        this.dialog
          .onOpenDialogResponsive(isMobile, HierarchyComponent, {}, 90)
          .subscribe((_) => { })
      );
    }
  }

  showCustomerThatUWork() {
    const profile = JSON.parse(sessionStorage.getItem("profile"));
    const refsId = this.hierarchyManagementService.getHierarchyRefs();
    this.hierarchySelectedWithName = this.hierarchyManagementService.getHierarchySelectedWithName();
    return !!profile
      ? `Stai operando su ${!!refsId ? this.getRefsId(refsId) : profile.customerReference
      } ${!!refsId && refsId.length === 1 ? "" : "-" + profile.customerName}`
      : "-";
  }

  showCodplateForDriver() {
    const profile = JSON.parse(sessionStorage.getItem("profile"));
    if (!!profile) {
      return !!profile
        ? `Stai operando sulla targa ${profile.plate
        }`
        : "";
    }
  }

  getRefsId(refsId): any {
    if (this.hierarchySelectedWithName == null) {
      this.hierarchySelectedWithName = this.hierarchyManagementService.getHierarchySelectedWithName();
    }
    if (refsId != null && refsId.length == 1) {

      if (this.hierarchySelectedWithName != null && this.hierarchySelectedWithName[0] != null) {
        let element = this.hierarchySelectedWithName[0];
        return `${element.idRef} - ${element.name} `
      }
    }
    return refsId.length > 3 ? `${refsId[0]},${refsId[1]}...` : refsId;
  }

}
